export const walmartMXTranslations = {
  strategyCTVHelperText:
    "Para medir las ventas a través de CTV, solicita al equipo de Walmart Connect (DSPcontacto@walmart.com) la generación de un código QR para integrarlo en tu video. El tiempo de respuesta es de 48 horas.",
  campaignCreateCostText: "Todas tus campañas en Walmart DSP contemplan incluidos los siguientes costos:",
  campaignCreateTechFeeText:
    "Tech Fee Estándar (12%) incluyendo: Fee Plataforma/Fee Optimización/PMP estándar fee/PMP optimizado fee/PG fee/Fee identificación",
  campaignCreateAudienceFeeText: "Fee Audiencia1st Party (25%)",
  campaignCreateSalesFeeText: "Fee Ventas Atribuidas (ROAS) (5%)",
  ntbDateRangeTooltipText:
    "Fecha inicio: Los datos de New to Brand (NTB) están disponibles para campañas hasta seis meses previos a la fecha actual.\nFecha fin: Considera hasta 72 horas previas para la actualización de los datos.",
  campaignsWithMeritPixelTooltipText:
    "Solo se podrán seleccionar campañas con ROI Pixels. Las campañas sin ROI Pixels no tienen datos de New to Brand.",
};
